import { render, staticRenderFns } from "./ExpirationSettings.vue?vue&type=template&id=c1d107fe"
import script from "./ExpirationSettings.vue?vue&type=script&lang=js"
export * from "./ExpirationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports